import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useFieldArray, useFormContext } from "react-hook-form";

import Button from "components/atoms/Button/Button";
import Textarea from "components/atoms/Textarea/Textarea";

export default function AdditionalInstructions({ placeholder }: AdditionalInstructionsProps) {
  const intl = useIntl();
  const { control, watch } = useFormContext();
  const { fields } = useFieldArray({
    control,
    name: "good_customs_information",
  });

  const [isAdditionalInstructionsEnabled, setIsAdditionalInstructionsEnabled] = useState(true);
  const additionalInformation = watch("additional_information");

  // Add the initial row of good customs information, and enable additional instructions if they exist
  useEffect(() => {
    if (additionalInformation) setIsAdditionalInstructionsEnabled(true);
  }, [fields, additionalInformation]);

  return (
    <>
      <Button
        variant="link"
        className="text-primary mt-lg py-0"
        label={
          isAdditionalInstructionsEnabled
            ? `- ${intl.formatMessage({
                id: "new-request.packing-list.removeAdditionalInformation",
                defaultMessage: "Remove additional information / instructions",
              })}`
            : `+ ${intl.formatMessage({
                id: "new-request.packing-list.addAdditionalInformation",
                defaultMessage: "Add additional information / instructions",
              })}`
        }
        onClick={() => setIsAdditionalInstructionsEnabled((prev) => !prev)}
      />
      {isAdditionalInstructionsEnabled && (
        <Textarea
          name="additional_information"
          placeholder={
            placeholder ??
            intl.formatMessage({
              id: "new-request.packing-list.addAdditionalInformation",
              defaultMessage: "Add additional information / instructions",
            })
          }
          rows={2}
          className="text-body w-392 ml-2 mt-2"
          validations={{ shouldUnregister: true }}
        />
      )}
    </>
  );
}

interface AdditionalInstructionsProps {
  placeholder?: string;
}
AdditionalInstructions.defaultProps = {
  placeholder: null,
};
